document.addEventListener('DOMContentLoaded', function () {
    const quickViewBtns = document.querySelectorAll('.quick-view-btn');
    const modal = document.getElementById('quick-view-modal');
    const closeModal = modal.querySelector('.close-modal');
    const modalTitle = document.getElementById('modal-title');
    const modalImages = document.getElementById('modal-images');
    const modalPrice = document.getElementById('modal-price');
    const modalVariants = document.getElementById('modal-variants');
    const addToCartButton = document.getElementById('add-to-cart');
    const modalSimilarProducts = document.getElementById('modal-similar-products');

    quickViewBtns.forEach(btn => {
        btn.addEventListener('click', function () {
            const productId = this.dataset.productId;

            // Fetch product data using Shopify's AJAX API
            fetch(`/products/${productId}.js`)
                .then(response => response.json())
                .then(product => {
                    // Set modal content
                    updateModalContent(product);
                });
        });
    });

    closeModal.addEventListener('click', function () {
        modal.classList.add('d-none');
    });

    addToCartButton.addEventListener('click', function () {
        const selectedVariant = document.querySelector('input[name="variant"]:checked');
        if (selectedVariant) {
            const variantId = selectedVariant.value;
            // Add to cart logic here
            console.log(`Adding variant ${variantId} to cart`);
        }
    });

    function updateModalContent(product) {
        // Set modal content
        modalTitle.textContent = product.title;
        modalPrice.textContent = Shopify.formatMoney(product.price);
        modalImages.innerHTML = product.images.map(image => `<img src="${image}" alt="${product.title} image">`).join('');
        
        // Show variants
        modalVariants.innerHTML = product.variants.map(variant => `
            <label>
                <input type="radio" name="variant" value="${variant.id}">
                ${variant.title}
            </label>
        `).join('');

        // Display similar products metafield
        const similarProducts = product.metafields.find(mf => mf.namespace === 'your_namespace' && mf.key === 'similar_products');
        modalSimilarProducts.innerHTML = '';
        if (similarProducts && similarProducts.value) {
            const similarProductIds = similarProducts.value.split(',');
            similarProductIds.forEach(id => {
                const trimmedId = id.trim();
                modalSimilarProducts.innerHTML += `
                    <span class="similar-product" data-product-id="${trimmedId}">${trimmedId}</span>
                `;
            });

            // Add click event to similar products
            const similarProductSpans = modalSimilarProducts.querySelectorAll('.similar-product');
            similarProductSpans.forEach(span => {
                span.addEventListener('click', function () {
                    const similarProductId = this.dataset.productId;
                    fetch(`/products/${similarProductId}.js`)
                        .then(response => response.json())
                        .then(similarProduct => {
                            updateModalContent(similarProduct);
                        });
                });
            });
        } else {
            modalSimilarProducts.innerHTML = '<div>No similar products available.</div>';
        }

        // Show the modal
        modal.classList.remove('d-none');
    }
});
